export const hasStorage =
  window &&
  window.localStorage &&
  window.localStorage.setItem &&
  window.localStorage.getItem;
